"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*
 * @Author: liujunhong
 * @Date: 2022/11/9
 * @Desc:  将组件渲染到页面的指定位置
 */

var Portal = function Portal(props) {
  var children = props.children,
    _props$container = props.container,
    container = _props$container === void 0 ? document.body : _props$container,
    _props$id = props.id,
    id = _props$id === void 0 ? 'portalContainer' : _props$id;
  var portalContainer = (0, _react.useRef)(document.createElement('div'));
  /**
   * 追加到元素内
   * @param container
   */
  var getPortalContainer = function getPortalContainer(container) {
    if (container === document.body) {
      return document.documentElement.appendChild(portalContainer.current);
    }
    if (typeof container === 'string') {
      var _document$querySelect;
      return (_document$querySelect = document.querySelector(container)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.appendChild(portalContainer.current);
    }
    if (typeof container === 'function') {
      return container().appendChild(portalContainer.current);
    }
    return container;
  };
  (0, _react.useEffect)(function () {
    if (container !== undefined) {
      getPortalContainer(container);
    }
    return function () {
      portalContainer.current.remove();
    };
  }, [container]);
  var jsx = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  return /*#__PURE__*/_reactDom.default.createPortal(jsx, portalContainer.current);
};
var _default = Portal;
exports.default = _default;